<script lang="ts">
  // One applied tag, in its colour, with an "x" to remove it. Shared by CustomActivityTags (tags on
  // an activity) and the dashboard's ActivityTagFilter (tags being filtered on).
  import { cn } from '@/lib/utils';
  import { tagVariants } from './ActivityTag';
  import { tagStyle } from './activityTagOptions';

  export let tag: string;
  // Undefined for a tag that's no longer on offer -- it falls back to the neutral pill.
  export let color: string | undefined = undefined;
  export let size: 'default' | 'medium' | 'small' = 'medium';
  // Omitted for a read-only pill (another athlete's activity): no "x" at all.
  export let onRemove: (() => void) | undefined = undefined;
  export let disabled = false;
</script>

<div
  class={cn(tagVariants({ variant: color ? 'colored' : 'custom', size }), 'gap-1 pr-1')}
  style={color ? tagStyle(color) : undefined}
>
  <span>{tag}</span>
  {#if onRemove}
    <button
      type="button"
      class="flex h-3.5 w-3.5 items-center justify-center rounded-full hover:bg-black/10 disabled:opacity-50"
      title="Remove tag"
      {disabled}
      on:click={(e) => { e.stopPropagation(); onRemove?.(); }}
    >
      <i class="fa-solid fa-xmark text-[9px]" aria-hidden="true"></i>
    </button>
  {/if}
</div>
